import React from 'react'
import injectSheet from 'react-jss'
import styles from './image-selectors.styles'
import Unsplash from './unsplash/unsplash.container'
import FormFile from 'pobble-components/dist/form-elements/form-file'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import ButtonElement from 'pobble-components/dist/button-element'

const ImageSelector = ({
  classes,
  defaultSearchValue,
  onUnsplashSelect,
  onFileSelect,
  onMainImageSelect,
  pending,
  presentation
}) => {
  return (
    <div>
      <Unsplash
        defaultSearchValue={defaultSearchValue}
        onUnsplashSelect={onUnsplashSelect}
        pending={pending}
      />
      <div className={classes.optionsHolder}>
        <div className={classes.option}>
          <FormLabel small>Upload your own image</FormLabel>
          <FormFile
            className={classes.uploadImageWrapper}
            accept=".png, .jpg, .jpeg"
            onChange={onFileSelect}>
            <div className={classes.uploadImage}>
              <FontAwesomeIcon
                className={classes.uploadIcon}
                icon={faPlusCircle}
              />
            </div>
          </FormFile>
        </div>
        {presentation.image &&
          onMainImageSelect && (
            <div className={classes.option}>
              <FormLabel small>Use cover image</FormLabel>
              <ButtonElement
                onClick={onMainImageSelect}
                className={classes.mainImage}
                style={{ backgroundImage: `url("${presentation.image.url}")` }}
              />
            </div>
          )}
      </div>
    </div>
  )
}

export default injectSheet(styles)(ImageSelector)
